import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { nameOfKind } from "../../services/cpln";
import { Policy } from "../../schema/types/policy/entity";
import { FormItem } from "../../components/antd/form/FormItem";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { FormItemValue } from "../../components/antd/form/FormItemValue";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpTextArea } from "../gvc/testNewForm/CpTextArea";
import { CpLabelDirtyIndicator } from "../gvc/testNewForm/CpLabelDirtyIndicator";

interface Props {
  policy: Policy;
}
export const Summary: React.FC<Props> = ({ policy }) => {
  const hasTagLinks =
    Object.entries(policy.tags || {}).filter(([_, value]) =>
      tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)),
    ).length > 0;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`description`}>
                <FormLabel>Description</FormLabel>
                <CpLabelDirtyIndicator name={`description`} />
              </CpLabel>
              <CpTextArea autoSize name={`description`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`description`} />
            </CpFormItem>
            {/* TODO can remove margin without requiring lastItem if formitem is under another formitem */}
            <FormItem className="flex flex-wrap gap-x-32 gap-y-8" lastItem={!hasTagLinks}>
              <FormItem lastItem>
                <FormLabel>Target Kind</FormLabel>
                <FormItemValue>{nameOfKind(policy.targetKind)}</FormItemValue>
              </FormItem>
              <FormItem lastItem>
                <FormLabel>Target All Items</FormLabel>
                <FormItemValue>{policy.target === "all" ? "Yes" : "No"}</FormItemValue>
              </FormItem>
            </FormItem>
            {hasTagLinks ? (
              <TagLinksTable
                tableId="policy-info-tag-links"
                tags={Object.entries(policy.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
